export const EXACT_LENGTH =
  (length: number) =>
  (value: string | undefined): string | undefined => {
    if (value && value.length !== length) {
      return `Must be ${length} character${length <= 1 ? '' : 's'}`;
    }

    return undefined;
  };
